export default {
  features: {
    applicationChangeCondition: {
      button: 'Tahrirlash',
      months: 'Oy',
    },
  },
};
